export const AUTHENTICATION_SUCCESS = 'AUTHENTICATION_SUCCESS';
export const SET_AUTH_TOKEN = 'SET_AUTH_TOKEN';
export const SET_IS_PM_USER = 'SET_IS_PM_USER';
export const SET_IS_PM_ADMIN = 'SET_IS_PM_ADMIN';
export const SET_SUPPLY_IS_PM_USER = 'SET_SUPPLY_IS_PM_USER';
export const SET_SUPPLY_IS_PM_ADMIN = 'SET_SUPPLY_IS_PM_ADMIN';
export const SET_TSS_AUTH_DATA = 'SET_TSS_AUTH_DATA';
